import { render, staticRenderFns } from "./background-video.vue?vue&type=template&id=578d8036&scoped=true&"
import script from "./background-video.ts?vue&type=script&lang=ts&"
export * from "./background-video.ts?vue&type=script&lang=ts&"
import style0 from "./background-video.styl?vue&type=style&index=0&id=578d8036&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578d8036",
  null
  
)

export default component.exports